import { render } from "./VvPointsCard.vue?vue&type=template&id=ad29068a&scoped=true"
import script from "./VvPointsCard.vue?vue&type=script&lang=js"
export * from "./VvPointsCard.vue?vue&type=script&lang=js"

import "./VvPointsCard.vue?vue&type=style&index=0&id=ad29068a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ad29068a"]])

export default __exports__